module.exports = __webpack_public_path__ + "img/inform.8cfb1e22.png";